import { Button, Layout, Spin, Upload, Image, message, DatePicker } from "antd";
import React, { useState } from "react";
import SideNavBar from "../../Components/SideBar/Sidebar";
import Navbar from "../../Components/Support/Header";
// import "./PRReports.css";
import "../../GlobalCss/SPF/PRReports.css";
import { BaseUrl, JsonConfig, FormConfig, UserName } from "../../Repository/BaseRepository";
import axios from "axios";
import { downloadIntegraUnmatchedXL, downloadIntegramasterFileXL } from "../../Repository/PRReportsRepository";
import { LoadingOutlined, DeleteOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
const { Header, Content } = Layout;
import moment from "moment";

const PRReportIntegra = ({ client: propClient }) => {
    const location = useLocation();
    const { client: locationClient } = location.state || {};
    const finalClient = propClient || locationClient || 'Integra';

    const [spin, setSpin] = useState(false)
    const [prreport, setPrreport] = useState([])
    const [prUploader, setPrUploader] = useState("");
    const [umSpin, setUmSpin] = useState(false)
    const [activeUpload, setActiveUpload] = useState([])
    const [activeUploader, setALUploader] = useState("")
    const [activespin, setActivespin] = useState(false)
    const [unmatched, setUnmatched] = useState([])
    const [umUploader, setUmUploader] = useState("")
    const [loader, setLoader] = useState(false)
    const [mfLoader, setMfloader] = useState(false)
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const disabledFutureDates = (current) => {
        // Disable future dates by ensuring date is not after today
        return current && current > moment().endOf("day");
    };

    const handleUpload = async (options) => {
        try {
            setSpin(true)
            const { file, onSuccess, onError } = options;
            const updatedDeductionFile = { file, status: "uploading" }
            const formData = new FormData();
            formData.append("inputFiles", file);
            setPrreport([])
            setPrUploader(file.name);
            const response = await axios.post(`${BaseUrl}PReports_/uploadDynamicInputFile?clients=${finalClient}`, formData, FormConfig)
            if (response.data.statusCode === 200) {
                onSuccess(file)
                message.success(`File uploaded successfully`);
                updatedDeductionFile.status = "done"
                setPrreport([updatedDeductionFile])
                setPrUploader('')
                setSpin(false)
            }
            else if (response.data.statusCode === 400) {
                onError(file)
                message.error(response.data.message);
                updatedDeductionFile.status = "error"
                setPrreport([updatedDeductionFile])
                setPrUploader('')
                setSpin(false)
            }
            else {
                onError(file)
                message.error(response.data.message);
                updatedDeductionFile.status = "error"
                setPrreport([updatedDeductionFile])
                setPrUploader('')
                setSpin(false)
            }
        }
        catch (error) {
            message.error(`File upload failed`);
            setPrUploader('')
            setSpin(false)
        }
    }
    const itemRender = (originNode, file) => {
        let statusColor;
        if (file.status === "done") {
            statusColor = "green";
        } else if (file.status === "error") {
            statusColor = "#f55451";
        }
        let fileExists = false;
        if (prreport.length > 0) {
            fileExists = true;
        }
        return <>
            <div style={{ display: "flex", height: 'auto', width: 200, wordWrap: "break-word", marginTop: "9px" }}>
                <div style={{ color: statusColor, height: 'auto', display: "flex", wordWrap: "break-word", borderRadius: "4px" }}>{fileExists ?
                    <div style={{ height: 'auto', width: 'fit-content', wordBreak: 'break-all', }}>{prreport[0].file.name} </div> : null}</div>
                <DeleteOutlined style={{ marginLeft: 5 }} onClick={() => setPrreport([])} />
            </div>
        </>;
    };

    const handleActiveUpload = async (options) => {
        try {
            setActivespin(true)
            const { file, onSuccess, onError } = options;
            const updatedDeductionFile = { file, status: "uploading" }
            const formData = new FormData();
            formData.append("active_file", file);
            setActiveUpload([])
            setALUploader(file.name);
            const response = await axios.post(`${BaseUrl}PReports_/PR_ActiveList`, formData, FormConfig)
            if (response.data.statusCode === 200) {
                onSuccess(file)
                message.success(`File uploaded successfully`);
                updatedDeductionFile.status = "done"
                setActiveUpload([updatedDeductionFile])
                setALUploader('')
                setActivespin(false)
            }
            else if (response.data.statusCode === 400) {
                onError(file)
                message.error(response.data.message);
                updatedDeductionFile.status = "error"
                setActiveUpload([updatedDeductionFile])
                setALUploader('')
                setActivespin(false)
            }
            else {
                onError(file)
                message.error(response.data.message);
                updatedDeductionFile.status = "error"
                setActiveUpload([updatedDeductionFile])
                setALUploader('')
                setActivespin(false)
            }
        }
        catch (error) {
            message.error(`File upload failed`);
            setALUploader('')
            setActivespin(false)
        }
    }
    const itemRenderActive = (originNode, file) => {
        let statusColor;
        if (file.status === "done") {
            statusColor = "green";
        } else if (file.status === "error") {
            statusColor = "#f55451";
        }
        let fileExists = false;
        if (activeUpload.length > 0) {
            fileExists = true;
        }
        return <>
            <div style={{ display: "flex", height: 'auto', width: 200, wordWrap: "break-word", marginTop: "9px" }}>
                <div style={{ color: statusColor, height: 'auto', display: "flex", wordWrap: "break-word", borderRadius: "4px" }}>{fileExists ?
                    <div style={{ height: 'auto', width: 'fit-content', wordBreak: 'break-all', }}>{activeUpload[0].file.name} </div> : null}</div>
                <DeleteOutlined style={{ marginLeft: 5 }} onClick={() => setActiveUpload([])} />
            </div>
        </>;
    };

    const handleUnmatchedUpload = async (options) => {
        try {
            setUmSpin(true)
            const { file, onSuccess, onError } = options;
            const updatedDeductionFile = { file, status: "uploading" }
            const formData = new FormData();
            formData.append("unmatchedData", file);
            setUnmatched([])
            setUmUploader(file.name);
            const response = await axios.post(`${BaseUrl}PReports_/uplaodDynamicunMatchedData?Client=${finalClient}`, formData, FormConfig)
            if (response.data.statusCode === 200) {
                onSuccess(file)
                message.success(`File uploaded successfully`);
                updatedDeductionFile.status = "done"
                setUnmatched([updatedDeductionFile])
                setUmUploader('')
                setUmSpin(false)
            }
            else if (response.data.statusCode === 204) {
                onError(file)
                message.info(response.data.message);
                updatedDeductionFile.status = "error"
                setUnmatched([updatedDeductionFile])
                setUmUploader('')
                setUmSpin(false)
            }
            else {
                onError(file)
                message.error(response.data.message);
                updatedDeductionFile.status = "error"
                setUnmatched([updatedDeductionFile])
                setUmUploader('')
                setUmSpin(false)
            }
        }
        catch (error) {
            message.error(`File upload failed`);
            setUmUploader('')
            setUmSpin(false)
        }
    }
    const itemRenderUnmatched = (originNode, file) => {
        let statusColor;
        if (file.status === "done") {
            statusColor = "green";
        } else if (file.status === "error") {
            statusColor = "#f55451";
        }
        let fileExists = false;
        if (unmatched.length > 0) {
            fileExists = true;
        }
    }

    const downloadList = async () => {
        try {
            setLoader(true)
            const response = await downloadIntegraUnmatchedXL(finalClient);
            setLoader(false)
        }
        catch {
            setLoader(false)
        }
    }
    const downloadmasterfile = async () => {
        try {
            setMfloader(true)
            if(fromDate && toDate){
            if (!fromDate || !toDate) {
                message.error("Please select both From Date and To Date");
                setMfloader(false);
                return;
            }

            // Check if the dates are the same
            if (fromDate.isSame(toDate, "day")) {
                message.error("From Date and To Date cannot be the same");
                setMfloader(false);
                return;
            }

            // Check if From Date is after To Date
            if (fromDate.isAfter(toDate)) {
                message.error("From Date cannot be after To Date");
                setMfloader(false);
                return;
            }
        }
            const response = await downloadIntegramasterFileXL(finalClient, fromDate, toDate);
            setMfloader(false)
            setFromDate(null);
            setToDate(null);
        }
        catch {
            setMfloader(false)
        }
    }

    return (
        <>
            <Layout style={{ backgroundColor: "white", height: "100vh", display: "flex", overflow: "hidden" }} >
                {/* <SideNavBar /> */}
                <Layout className="whole-div">
                    <Header className="timecards-header">
                        {/* <Navbar /> */}
                    </Header>
                    <Content style={{ height: "100%", overflow: "auto" }}>
                        <div className="prupload-div">
                            <div className="prfile-upload">
                                <Upload
                                    className="pr-upload-file"
                                    name="file"
                                    customRequest={handleActiveUpload}
                                    itemRender={itemRenderActive}
                                    fileList={activeUpload}
                                    accept=".xls,.xlsx"
                                    onRemove={() => setActiveUpload([])}
                                    style={{ border: "1px solid #002766", borderRadius: 10, borderStyle: "dashed" }}
                                >
                                    <div className='pr-content-file'>
                                        <span className="hrfile-name">Upload Active List</span>
                                        {activespin ? <Spin indicator={<LoadingOutlined className="upload-spinner" style={{ fontSize: 16, marginLeft: 7 }} spin />} />
                                            : <Image src="./Images/uploadimg.png"
                                                style={{
                                                    border: "none",
                                                    width: 19,
                                                    height: 17,
                                                }}
                                                showPreviewIcon={false}
                                                preview={false} />}
                                    </div>
                                </Upload>
                                {activeUploader.length > 0 ? <div style={{ width: 'fit-content', maxWidth: 200, wordBreak: 'break-all', marginBottom: 2, color: "rgba(0, 39, 102, 1)" }}>{activeUploader}</div> : null}
                            </div>
                            <div className="prfile-upload">
                                <Upload
                                    className="pr-upload-file"
                                    name="file"
                                    customRequest={handleUpload}
                                    itemRender={itemRender}
                                    fileList={prreport}
                                    accept=".xls,.xlsx"
                                    onRemove={() => setPrreport([])}
                                    style={{ border: "1px solid #002766", borderRadius: 10, borderStyle: "dashed" }}
                                >
                                    <div className='pr-content-file'>
                                        <span className="hrfile-name">Upload PR Integra</span>
                                        {spin ? <Spin indicator={<LoadingOutlined className="upload-spinner" style={{ fontSize: 16, marginLeft: 7 }} spin />} />
                                            : <Image src="./Images/uploadimg.png"
                                                style={{
                                                    border: "none",
                                                    width: 19,
                                                    height: 17,
                                                }}
                                                showPreviewIcon={false}
                                                preview={false} />}
                                    </div>
                                </Upload>
                                {prUploader.length > 0 ? <div style={{ width: 'fit-content', maxWidth: 200, wordBreak: 'break-all', marginBottom: 2, color: "rgba(0, 39, 102, 1)" }}>{prUploader}</div> : null}
                            </div>
                            <div className="unmatched-download">
                                 <Button className="sync-button-enable" onClick={downloadList} loading={loader}>
                                                                Unmatched list download</Button>
                                
                            </div>
                            <div className="unmatchedfile-upload">
                                <Upload
                                    className="unmatched-upload-file"
                                    name="file"
                                    customRequest={handleUnmatchedUpload}
                                    itemRender={itemRenderUnmatched}
                                    fileList={unmatched}
                                    accept=".xls,.xlsx"
                                    onRemove={() => setUnmatched([])}
                                    style={{ border: "1px solid #002766", borderRadius: 10, borderStyle: "dashed" }}
                                >
                                    <div className='unmatched-content-file'>
                                        <span className="hrfile-name">Upload Unmatched list</span>
                                        {umSpin ? <Spin indicator={<LoadingOutlined className="upload-spinner" style={{ fontSize: 16, marginLeft: 7 }} spin />} />
                                            : <Image src="./Images/uploadimg.png"
                                                style={{
                                                    border: "none",
                                                    width: 19,
                                                    height: 17,
                                                }}
                                                showPreviewIcon={false}
                                                preview={false} />}
                                    </div>
                                </Upload>
                                {umUploader.length > 0 ? <div style={{ width: 'fit-content', maxWidth: 200, wordBreak: 'break-all', marginBottom: 2, color: "rgba(0, 39, 102, 1)" }}>{umUploader}</div> : null}
                            </div>

                        </div>
                     
                        <div className="unmatched-div">
                            <div className="unmatched-download">
                            <DatePicker
                                    placeholder="Select From Date"
                                    value={fromDate}
                                    onChange={(date) => setFromDate(date)}
                                    format="MM-DD-YYYY"
                                    style={{ marginRight: 20, height: "38px", marginLeft: "50px" }}
                                    disabledDate={disabledFutureDates} 
                                />
                                <DatePicker
                                    placeholder="Select To Date"
                                    value={toDate}
                                    onChange={(date) => setToDate(date)}
                                    format="MM-DD-YYYY"
                                    style={{ marginRight: 20, height: "38px" }}
                                    disabledDate={disabledFutureDates} 
                                />
                                <Button className="sync-button-enable" onClick={downloadmasterfile} loading={mfLoader}>
                                    Download Masterfile</Button>
                            
                            </div>
                        </div>

                    </Content>
                </Layout>
            </Layout>
        </>
    )
}
export default PRReportIntegra;